import { isModuleActive } from "@/functions/moduleConfig";

// import main api definitions
const apiDefinitions: {
  [key: string]: any;
} = {};

const apis: Record<string, { default: any }> = import.meta.glob("./*.js", {
  eager: true,
});

Object.keys(apis).forEach((module) => {
  if (!module.startsWith("./api")) {
    const path = `${module.slice(2).slice(0, -3)}`;
    apiDefinitions[path] = apis[module].default;
    apiDefinitions[path].path = path;
  }
});

const licenseApis: Record<string, { default: any }> = import.meta.glob("../license/**/api/*.js", {
  eager: true,
});

const moduleApis: Record<string, { default: any }> = import.meta.glob("../modules/**/api/*.js", {
  eager: true,
});

function addModuleApi(path: string, module: { default: any }) {
  const moduleName = path.slice(2).split("/")[2];
  const [apiName] = path.slice(0, -3).split("/").slice(-1);
  const key = `${moduleName}$${apiName.charAt(0).toUpperCase() + apiName.slice(1)}`;
  apiDefinitions[key] = module.default;
  apiDefinitions[key].path = `${moduleName}/${apiName}`;
}

// import license api definitions
Object.entries(licenseApis).forEach(([path, module]) => {
  if (isModuleActive(path.slice(2).slice(0, -3).split("/")[2])) {
    addModuleApi(path, module);
  }
});

Object.entries(moduleApis).forEach(([path, module]) => addModuleApi(path, module));

export default apiDefinitions;
